export function parseToValidPhone(number) {
  if (typeof number !== 'string') {
    return number;
  }
  if (/^(\+324)/i.test(number)) {
    return '+32 4' + number.slice(4).replace(/(\d{2})/g, '$1 ').replace(/(\s+$)/,'');
  } else if (/^(04)/i.test(number)) {
    return number.replace(/(\d{2})/g, '$1 ').replace(/(\s+$)/,'');
  } else if ((/^(\+3204)/i.test(number))) {
    return '+32 (0)4' + number.slice(5).replace(/(\d{2})/g, '$1 ').replace(/(\s+$)/,'');
  } else {
    return number;
  }
}